import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown, false = not logged, object = logged
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tq_token");
    const cached = localStorage.getItem("tq_user");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    if (cached) {
      try { setUser(JSON.parse(cached)); } catch { /* ignore */ }
    }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("tq_user", JSON.stringify(r.data));
    }).catch(() => {
      setUser(false);
      localStorage.removeItem("tq_token");
      localStorage.removeItem("tq_user");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (pin) => {
    const { data } = await api.post("/auth/login", { pin });
    localStorage.setItem("tq_token", data.token);
    localStorage.setItem("tq_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tq_token");
    localStorage.removeItem("tq_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function homeForRole(role) {
  if (role === "root") return "/admin/root";
  if (role === "mesero") return "/admin/mesero";
  if (role === "caja") return "/admin/caja";
  if (role && role.startsWith("taquero")) return "/admin/taquero";
  return "/admin/login";
}
